import { Card, CardContent } from "@/components/ui/card";
import { Skeleton } from "@/components/ui/skeleton";
import { BRAND } from "@/lib/constants";

// Shared formatters — still consumed by DocumentTable + DocumentDetailDialog.
function formatBytes(bytes) {
  if (!bytes) return "0 B";
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(0)} KB`;
  if (bytes < 1024 * 1024 * 1024) return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
  return `${(bytes / (1024 * 1024 * 1024)).toFixed(2)} GB`;
}

function formatDate(d) {
  if (!d) return "--";
  try {
    return new Date(d).toLocaleDateString("en-CH", {
      year: "numeric",
      month: "short",
      day: "numeric",
    });
  } catch {
    return d;
  }
}

export { formatBytes, formatDate };

function MetricCard({ label, value, accent }) {
  return (
    <Card>
      <CardContent className="p-4">
        <p className="text-[10px] font-medium text-gray-400 uppercase tracking-wider mb-1">
          {label}
        </p>
        <p
          className="text-xl font-bold"
          style={accent ? { color: BRAND.text } : { color: "#111827" }}
        >
          {value}
        </p>
      </CardContent>
    </Card>
  );
}

export default function DocumentStats({ stats, loading }) {
  if (loading) {
    return (
      <div className="grid grid-cols-2 gap-3">
        {[...Array(2)].map((_, i) => (
          <Card key={i}>
            <CardContent className="p-4 space-y-2">
              <Skeleton className="h-3 w-20" />
              <Skeleton className="h-6 w-16" />
            </CardContent>
          </Card>
        ))}
      </div>
    );
  }

  const portalCount = stats?.per_portal?.length || 0;

  return (
    <div className="grid grid-cols-2 gap-3">
      <MetricCard
        label="Total Documents"
        value={stats?.total_documents?.toLocaleString("en-US") ?? "0"}
        accent
      />
      <MetricCard
        label="Portals"
        value={portalCount}
      />
    </div>
  );
}
